import { render, staticRenderFns } from "./IconCartAdd.vue?vue&type=template&id=c42e74f4&"
import script from "./IconCartAdd.vue?vue&type=script&lang=ts&"
export * from "./IconCartAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports